import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/services/spinner.service';
import {documentoService} from 'src/app/services/documento.service'
import { setConfigTable, validarCodigoExistentesComercial, basicAlert, alertaConfirmacionHTML3, obtenerFechaSeleccionada, obtenerFechaActual, timerOut, filtrarCoincidenciaArrayTransportista, validarInputVacio, alertaConfirmacion, openDescripcion, openObservacion, alertaConfirmacionHTML } from 'src/app/shared/utils';
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-md-actualizar-placa',
  templateUrl: './md-actualizar-placa.component.html',
  styleUrls: ['./md-actualizar-placa.component.css']
})
export class MdActualizarPlacaComponent implements OnInit {

  constructor(
    private spinnerService: SpinnerService,
    private modalactiveService: NgbActiveModal,
    private toastr: ToastrService,
    private documentoService: documentoService,
    private modalService: NgbModal,
    ) { }

  ngOnInit(): void {
    
  }
  @Input() valorPlaca;
  valorEtiqueta
  @Input() valEtiqueta;
  _ok(){
    this.spinnerService.activarLoading(true);
    this.documentoService.actualiza_placa(this.valEtiqueta,this.valorPlaca).subscribe((response:any)=>{
      this.spinnerService.activarLoading(false);
      console.log(response);
      this.toastr.success("Se modificó correctamente")
      this.modalactiveService.close();
    }, err=>{
      console.log(err);
      this.spinnerService.activarLoading(false);
      basicAlert('Servicio no disponible','warning','Aceptar',null,null,null);
    }
    )  
  }
  _close() {
    this.modalactiveService.dismiss('canceling');
  }

}
